import type { SaveSearchMode } from "../../../types/saved-searches";

import {
    getTriggerCancelActionTrackingNameBy,
    getTriggerSaveActionTrackingNameBy,
    getTriggerTrackingNameBy,
} from "./utils";

export default function createSaveSearchTrackingService(
    trackEvent: (category: string, action: string, eventName: string) => void,
) {
    const trackSaveSearchTriggerEvent = (action: string, eventName: string) => {
        trackEvent("save search trigger", action, eventName);
    };

    const trackFilterActionsEvent = (action: string, eventName: string) => {
        trackEvent("lead gen filter actions", action, eventName);
    };

    return {
        manual: {
            trackSaveSearchConfirmed(name: string) {
                trackFilterActionsEvent("save", `save search/${name}`);
            },
            trackSaveSearchCanceled() {
                trackFilterActionsEvent("cancel", `save search`);
            },
        },
        onExport: {
            trackSaveSearchConfirmed() {
                trackSaveSearchTriggerEvent("click apply", "apply save after export");
            },
            trackSaveSearchCanceled() {
                trackSaveSearchTriggerEvent("click cancel", "cancel save after export");
            },
        },

        trackConfirmTriggerSaveAction(saveMode: SaveSearchMode | undefined) {
            const eventName = getTriggerSaveActionTrackingNameBy(saveMode);

            trackSaveSearchTriggerEvent("click save search", eventName);
        },
        trackCancelTriggerSaveAction(saveMode: SaveSearchMode | undefined) {
            const eventName = getTriggerCancelActionTrackingNameBy(saveMode);

            trackSaveSearchTriggerEvent("click don't save", eventName);
        },

        trackDefaultSearchNameChange(saveMode: SaveSearchMode) {
            const triggerTrackingName = getTriggerTrackingNameBy(saveMode);

            trackSaveSearchTriggerEvent("change name", `change default save search name/${triggerTrackingName}`);
        },
    };
}
